export default function FollowInstaText() {
  return <section className="instagram-heading"><h2>Follow Us On Instagram <a href="https://www.instagram.com/socialpawsapp/" target="_blank" rel="noopener noreferrer">@socialpawsapp</a></h2></section>;
}
